module.exports = __webpack_public_path__ + "static/media/FeatureCAM.ec46f9fd.png";